import { __decorate } from "tslib";
import { Component, ViewEncapsulation } from '@angular/core';
import { SharedHttp } from '../../../services/http-client.service';
import { ComponentService } from './../../../services/component.service';
import { ConfirmComponent } from './../../confirm';
import { WebsiteThemeService } from '../../../services/website-theme.service';
import { DomSanitizer } from '@angular/platform-browser';
import { NewEAccountComponent } from '../new-eaccount';
import { AuthService } from '../../../services/auth.service';
import { catchError } from "rxjs/operators";
import { of } from "rxjs";
import { LanguageService } from "../../../services/language.service";
import { NewBankAccountComponent } from '../new-bank-account';
import { BankaccountWhitelistInfoExchangeComponent } from '../../bankaccount-whitelist-info-exchange/bankaccount-whitelist-info-exchange.component';
/**
 * Accounts Component
 */
let AccountsComponent = class AccountsComponent {
    constructor(httpClient, compService, sanitizer, themeService, auth, languageService) {
        this.httpClient = httpClient;
        this.compService = compService;
        this.sanitizer = sanitizer;
        this.themeService = themeService;
        this.auth = auth;
        this.languageService = languageService;
        this.bankAccounts = [];
        this.cryptoAccounts = [];
        this.mainColor = '';
        this.accentColor = '';
        this.textColor = '';
        this.borderRadiusSmaller = '';
        this.borderRadiusLarger = '';
        this.linkColor = '';
        this.user = {};
        this.loggedIn = false;
        this.isCompany = false;
        this.sources = ["exchange", "wallet"];
        this.addressesLoaded = false;
        this.addressLengthBreakpoint = 20;
        this.statusApproved = 'APPROVED';
        this.waitingForApprovalStatus = 'WAITING_FOR_APPROVAL';
        this.auth.getStatus().subscribe((result) => {
            this.loggedIn = result;
        });
        this.auth.fetchUser().then(() => {
            this.user = JSON.parse(localStorage.getItem('user'));
            this.isCompany = (this.user.is_company_user && this.user.is_company_user == 1) ? true : false;
        });
        this.languageService.getChosenLanguage().subscribe((lang) => {
            this.lang = lang ? lang : 'en';
        });
        this.themeService.getTheme().subscribe((data) => {
            this.mainColor = this.themeService.getStyleAttribute('main_color');
            this.accentColor = this.themeService.getStyleAttribute('accent_color');
            this.textColor = this.themeService.getStyleAttribute('text_color');
            this.borderRadiusSmaller = this.themeService.getStyleAttribute('border_radius_smaller');
            this.borderRadiusLarger = this.themeService.getStyleAttribute('border_radius_larger');
            this.linkColor = this.themeService.getStyleAttribute('link_color');
        });
    }
    ngOnInit() {
        this.getAccounts();
        this.getCrypto();
    }
    getAccounts() {
        this.httpClient.get('user/getbankaccounts').subscribe((result) => {
            this.bankAccounts = result;
        });
    }
    getCrypto() {
        this.addressesLoaded = false;
        this.httpClient.get('user/getcryptoaddressesinfo').subscribe((result) => {
            this.cryptoAccounts = result;
            this.cryptoAccounts.forEach(cryptoaccount => cryptoaccount.source = this.sources[0]);
            this.cryptoAccounts.sort((a, b) => a.cur_code.localeCompare(b.cur_code));
            this.getWhitelistedAddresses();
        });
    }
    getWhitelistedAddresses() {
        this.httpClient.get('wallet/whitelist').pipe(catchError(err => of([]))).subscribe((data) => {
            if (data['message']) {
                data['message'].forEach(cryptoaccount => cryptoaccount.source = this.sources[1]);
                data['message'].sort((a, b) => a.currency.localeCompare(b.currency));
                this.cryptoAccounts = this.cryptoAccounts.concat(data['message']);
                this.addressesLoaded = true;
            }
            else {
                this.addressesLoaded = true;
            }
        });
    }
    deleteCrypto(event, item) {
        this.compService.openModal(ConfirmComponent, {
            title: 'DELETE_ACCOUNT'
        }, (success) => {
            const targ = event.target || event.srcElement;
            if (item.source === 'exchange') {
                this.httpClient.post('user/deletesavedaddress', {
                    address_id: item.address_id
                }).subscribe((result) => {
                    this.cryptoAccounts = this.cryptoAccounts.filter(address => address.address_id ? address.address_id !== item.address_id : true);
                });
            }
            else {
                const deleteAddressData = {
                    address: item.verboseId,
                    currency: item.currency
                };
                this.httpClient.post('wallet/deleteaddressfromwhitelist', deleteAddressData).subscribe((data) => {
                    this.cryptoAccounts = this.cryptoAccounts.filter(address => address.id ? address.id !== item.id : true);
                });
            }
        });
    }
    deleteBank(event, id) {
        this.compService.openModal(ConfirmComponent, {
            title: 'DELETE_ACCOUNT'
        }, (sucess) => {
            const targ = event.target || event.srcElement;
            this.httpClient.post('user/deletebankaccount', {
                account_id: id
            }).subscribe((result) => {
                //targ.parentElement.parentElement.remove();
                this.getAccounts();
            });
        });
    }
    openNewBankAccount() {
        if (this.isCompany) {
            this.compService.openModal(NewBankAccountComponent, {
                title: 'NEW_ACCOUNT_ADDED'
            }, (success) => {
                this.getAccounts();
            });
        }
        else {
            this.compService.openModal(BankaccountWhitelistInfoExchangeComponent, {
                pendingProcess: this.bankAccounts.some(account => account.status === this.waitingForApprovalStatus),
            });
        }
    }
    openNewEAccount() {
        this.compService.openModal(NewEAccountComponent, {
            title: 'NEW_EACCOUNT_ADDED',
            sources: this.sources
        }, (success) => {
            this.getCrypto();
        });
    }
    showAddressWithEllipsis(address) {
        return address.substr(0, 10) + '...' + address.substr(address.length - 10, address.length);
    }
};
AccountsComponent.ctorParameters = () => [
    { type: SharedHttp },
    { type: ComponentService },
    { type: DomSanitizer },
    { type: WebsiteThemeService },
    { type: AuthService },
    { type: LanguageService }
];
AccountsComponent = __decorate([
    Component({
        selector: 'ecd-accounts',
        encapsulation: ViewEncapsulation.None,
        template: __importDefault(require("./accounts.component.html")).default
    })
], AccountsComponent);
export { AccountsComponent };
